module.exports = {"TXTCLI_Places_paid":{"id":"TXTCLI_Places_paid","defaultMessage":"Θέσεις που πληρώνονται"}}